import {
  Squares2X2Icon,
  KeyIcon,
  UserMinusIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";

export default function AdminActions({ showGenerateReports = false, permission }) {
  return (
    <div className="w-full rounded-2xl shadow-sm p-6 bg-white">
      <h2 className="text-md font-medium text-gray-500 mb-3">Admin Actions</h2>

      <div className="flex flex-col gap-3">
        {/* Assign Applications */}
        <div className="flex items-center gap-3 bg-secondary-50 hover:bg-primary-100 rounded-xl px-4 py-4 cursor-pointer h-[68px]">
          <Squares2X2Icon className="w-7 h-7 text-primary-500" />
          <span className="text-gray-700 font-medium">Assign Applications</span>
        </div>
        {/* Conditionally show Generate Reports */}
        {showGenerateReports && (
          <div className="flex items-center gap-3 bg-secondary-50 hover:bg-blue-100 rounded-xl px-4 py-4 cursor-pointer h-[68px]">
            <DocumentTextIcon className="w-7 h-7 text-blue-500" />
            <span className="text-gray-700 font-medium">Generate Reports</span>
          </div>
        )}
        {/* Reset Password */}
        <div className="flex items-center gap-3 bg-secondary-50 hover:bg-green-100 rounded-xl px-4 py-4 cursor-pointer h-[68px]">
          <KeyIcon className="w-7 h-7 text-green-500" />
          <span className="text-gray-700 font-medium">Reset Password</span>
        </div>

        {/* Deactivate Account */}
        <div className="flex items-center gap-3 bg-secondary-50 hover:bg-orange-100 rounded-xl px-4 py-4 cursor-pointer h-[68px]">
          <UserMinusIcon className="w-7 h-7 text-orange-500" />
          <span className="text-gray-700 font-medium">Deactivate Account</span>
        </div>


      </div>

      <div className="flex justify-between mt-5 gap-3">
        {permission?.deleteSingle === true &&
          <button className="flex-1 border border-primary-600 text-primary-600 font-medium rounded-xl py-4 hover:bg-primary-50">
            Delete
          </button>
        }
        {permission?.edit === true &&
        <button className="flex-1 bg-primary-600 text-white font-medium rounded-xl py-4 hover:bg-primary-700">
          Edit
        </button>
}
      </div>
    </div>
  );
}
